import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9edbfa34")

_pushScopeId("data-v-9edbfa34")
const _hoisted_1 = {
  key: 0,
  class: "el-icon-plus"
}
const _hoisted_2 = {
  key: 0,
  class: "el-upload__tip"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_upload, {
      class: "upload-demo",
      action: _ctx.action,
      headers: _ctx.headers,
      data: _ctx.data,
      disabled: _ctx.disabled,
      multiple: _ctx.multiple,
      limit: _ctx.limit,
      ref: "upload",
      "file-list": _ctx.fileList,
      "list-type": _ctx.listType,
      accept: _ctx.accept,
      "on-preview": _ctx.handlePreview,
      "on-remove": _ctx.handleRemove,
      "before-remove": _ctx.beforeRemove,
      "on-exceed": _ctx.handleExceed,
      "on-success": _ctx.handleSuccess,
      "on-error": _ctx.handleError,
      "on-progress": _ctx.handleProgress,
      "before-upload": _ctx.handleBeforeUpload
    }, {
      tip: _withId(() => [
        (_ctx.isTip)
          ? (_openBlock(), _createBlock("div", _hoisted_2, " 支持 " + _toDisplayString(_ctx.fileType) + " 文件，最大不超过 " + _toDisplayString(_ctx.maxSizeView) + "，最多只能上传 " + _toDisplayString(_ctx.limit) + " 个文件 ", 1))
          : _createCommentVNode("", true)
      ]),
      default: _withId(() => [
        (_ctx.listType === 'picture-card')
          ? (_openBlock(), _createBlock("i", _hoisted_1))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              size: "small",
              type: "primary",
              disabled: _ctx.disabled
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.btnText), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
      ]),
      _: 1
    }, 8, ["action", "headers", "data", "disabled", "multiple", "limit", "file-list", "list-type", "accept", "on-preview", "on-remove", "before-remove", "on-exceed", "on-success", "on-error", "on-progress", "before-upload"]),
    (_ctx.isViewer)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": [_ctx.currentPicUrl],
          onClose: _ctx.handleViewerClose
        }, null, 8, ["url-list", "onClose"]))
      : _createCommentVNode("", true)
  ]))
})